/**
 * Created by Valera on 031 31.10.16.
 */
(function () {
    var tList = $('.tab-list');
    tList.on("click",function (e) {
        var target = e.target,
            index = $(target).index()+1,
            link = '#tabs-'+index;

        $(target).addClass('active')
                    .siblings()
                    .removeClass("active");

        $(link).removeClass('is-hide')
            .siblings()
            .addClass('is-hide');
    })
})();